// Shared PilotLeadGen Logo Component
// Used across all screens — replace the "P" mark with the real logo

export default function Logo({ size = 36, showText = true, textSize = 17 }) {
  return (
    <div style={{ display:'flex', alignItems:'center', gap:10 }}>
      <img
        src="/pilotleadgen-logo.png"
        alt="PilotLeadGen"
        style={{
          width:  size,
          height: size,
          objectFit: 'contain',
          borderRadius: 8,
        }}
      />
      {showText && (
        <span style={{
          fontSize:      textSize,
          fontWeight:    800,
          color:         '#1e293b',
          fontFamily:    'sans-serif',
          letterSpacing: '-0.3px',
        }}>
          PilotLeadGen
        </span>
      )}
    </div>
  );
}